import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import Icon from '../../../components/AppIcon';

const ThemeSettings = () => {
  const { theme, setThemeMode } = useTheme();

  const themes = [
    { id: 'light', label: 'Light Mode', icon: 'Sun' },
    { id: 'dark', label: 'Dark Mode', icon: 'Moon' },
    { id: 'device', label: 'Device Preference', icon: 'Monitor' }
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {themes.map(themeOption => (
          <button
            key={themeOption.id}
            onClick={() => setThemeMode(themeOption.id)}
            className={`
              p-4 rounded-lg border-2 transition-all duration-200
              ${theme === themeOption.id
                ? 'border-primary bg-primary/10'
                : 'border-border hover:border-primary/50'
              }
            `}
          >
            <Icon name={themeOption.icon} size={24} className="mb-2" />
            <p className="text-sm font-medium text-foreground">{themeOption.label}</p>
            {theme === themeOption.id && (
              <div className="mt-2 flex items-center gap-1">
                <Icon name="Check" size={16} color="var(--color-primary)" />
                <span className="text-xs text-primary font-semibold">Active</span>
              </div>
            )}
          </button>
        ))}
      </div>
      <p className="text-sm text-muted-foreground mt-4">
        Changes are applied immediately. Your preference is automatically saved.
      </p>
    </div>
  );
};

export default ThemeSettings;
